// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IuNTpLCs57EUFEYNNIxd{flex-direction:column;gap:40px;padding:37px 23px 0;display:flex}.gKhbY_pLOZstsd1v5tRr{flex-direction:column;display:flex}.rXkZe1R8Sw0Cn0FrN4Mr{padding-bottom:20px}.wSg2UOyYL3Q_fN0Gio5a{color:var(--content-primary-disabled)}.x1vztFyo_MJYpahFBZid{flex-direction:column;display:flex}.x1vztFyo_MJYpahFBZid+.x1vztFyo_MJYpahFBZid{margin-top:32px}.Ka97x82qPb89B9tYnwzL{color:var(--content-primary-primary);padding-bottom:16px}.u0OAI4aa1fYp1pa_geiX{flex-direction:row;gap:12px;display:flex}.u0OAI4aa1fYp1pa_geiX+.u0OAI4aa1fYp1pa_geiX{margin-top:20px}.IbQFj0l6eTc4XUlPJo2F{width:130px;min-width:130px;max-width:130px;color:var(--content-primary-tertiary);padding:4px 0}.F3jJk0FxEH0WX8W7Ffa2{text-overflow:ellipsis;color:var(--content-primary-primary);padding:4px 0;overflow:hidden}.ooQotNOIgMbAS2R8rmHC{color:var(--content-primary-disabled)}.XQaSlxpt9oUWFd5Siijy{flex-wrap:wrap;flex:1;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContent": `IuNTpLCs57EUFEYNNIxd`,
	"section": `gKhbY_pLOZstsd1v5tRr`,
	"head": `rXkZe1R8Sw0Cn0FrN4Mr`,
	"empty": `wSg2UOyYL3Q_fN0Gio5a`,
	"group": `x1vztFyo_MJYpahFBZid`,
	"subHead": `Ka97x82qPb89B9tYnwzL`,
	"actionRow": `u0OAI4aa1fYp1pa_geiX`,
	"name": `IbQFj0l6eTc4XUlPJo2F`,
	"value": `F3jJk0FxEH0WX8W7Ffa2`,
	"placeholder": `ooQotNOIgMbAS2R8rmHC`,
	"tags": `XQaSlxpt9oUWFd5Siijy`
};
export default ___CSS_LOADER_EXPORT___;
